import { RequestConfig } from '~/common/services/requests';
import {
  PlatformRequestOptions,
  RequestsApi,
} from '../../../../contexts/RequestsContext';

export const constructPatchRequest = async <ResponseType>(
  performRequest: RequestsApi['platformRequest'],
  patchPath: string,
  config: RequestConfig,
  options?: PlatformRequestOptions,
): Promise<ResponseType | undefined> =>
  performRequest<ResponseType>(
    { method: 'PATCH', url: patchPath, ...config },
    options,
  );
